import { useEffect, useRef } from "react";

const RazorpayButton = ({ buttonId }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !buttonId) return;
    ref.current.innerHTML = "";
    const form = document.createElement("form");
    ref.current.appendChild(form);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    script.setAttribute("data-payment_button_id", buttonId);
    script.async = true;
    form.appendChild(script);
  }, [buttonId]);

  if (!buttonId) return null;
  return (
    <div className="mt-9">
      <div ref={ref} data-testid="razorpay-pay-button" />
      <p className="mt-3 font-mono2 text-[10px] tracking-[0.15em] text-[#5A5D4E]">
        SECURE PAYMENT BY RAZORPAY · UPI / CARDS / NETBANKING
      </p>
    </div>
  );
};

export default RazorpayButton;
